// Autogenerated file
export const fuelTankTypesEnum = {
    Diesel: "Diesel",
    Gas: "Gas",
};
export const fuelTankTypes = [
    { label: "Дизель", value: "Diesel" },
    { label: "Газ", value: "Gas" },
];
